// @deprecated
export var tpBorderRadiusBase = "4px";
// @deprecated
export var tpBorderRadiusBig = "6px";
// @deprecated
export var tpBorderRadiusFull = "50%";
// @deprecated
export var tpBorderRadiusSides = "9999px";
export var tpBreakpointLarge = "1025px";
export var tpBreakpointLargeValue = 1025;
export var tpBreakpointMedium = "700px";
export var tpBreakpointMediumValue = 700;
export var tpBreakpointSmall = "481px";
export var tpBreakpointSmallValue = 481;
export var tpBreakpointSplitViewMedium = "1060px";
export var tpBreakpointSplitViewMediumValue = 1060;
export var tpBreakpointSplitViewSmall = "769px";
export var tpBreakpointSplitViewSmallValue = 769;
export var tpColorBlue100 = "#eaf6fa";
export var tpColorBlue200 = "#b3ebff";
export var tpColorBlue300 = "#79d2f2";
export var tpColorBlue = "#009fd9";
export var tpColorBlue500 = "#007fad";
export var tpColorBlue600 = "#005979";
export var tpColorIndigo100 = "#e8f1fd";
export var tpColorIndigo200 = "#cce1ff";
export var tpColorIndigo300 = "#96c2ff";
export var tpColorIndigo = "#5968e2";
export var tpColorIndigo500 = "#4f54b3";
export var tpColorIndigo600 = "#383c80";
export var tpColorPurple100 = "#f5efff";
export var tpColorPurple200 = "#dfccff";
export var tpColorPurple300 = "#c9acfd";
export var tpColorPurple = "#8d56eb";
export var tpColorPurple500 = "#6637b6";
export var tpColorPurple600 = "#492782";
export var tpColorGreen100 = "#e1fdf3";
export var tpColorGreen200 = "#c6f7da";
export var tpColorGreen300 = "#73e4a2";
export var tpColorGreen = "#2db783";
export var tpColorGreen500 = "#16855b";
export var tpColorGreen600 = "#054e33";
export var tpColorYellow100 = "#fdf7e7";
export var tpColorYellow200 = "#ffebb3";
export var tpColorYellow300 = "#ffdd80";
export var tpColorYellow = "#febe14";
export var tpColorYellow500 = "#a77005";
export var tpColorYellow600 = "#714601";
export var tpColorRed100 = "#ffeff0";
export var tpColorRed200 = "#ffd9d9";
export var tpColorRed300 = "#ffb0b0";
export var tpColorRed = "#ff5a5f";
export var tpColorRed500 = "#b22d31";
export var tpColorRed600 = "#7d0d10";
export var tpColorBlack300 = "#676d73";
export var tpColorBlack = "#2f3033";
export var tpColorGray200 = "#fafafa";
export var tpColorGray300 = "#e9eced";
export var tpColorGray = "#d3d4d5";
export var tpColorWhite = "#ffffff";
export var tpCornerRadiusBase = "4px";
export var tpCornerRadiusBig = "6px";
export var tpCornerRadiusFull = "50%";
export var tpCornerRadiusSides = "9999px";
export var tpDuration1 = 75;
export var tpDuration2 = 150;
export var tpDuration3 = 200;
export var tpDuration4 = 250;
export var tpDuration5 = 300;
export var tpDuration6 = 350;
export var tpEaseIn = "cubic-bezier(0.50, 0, 1, 1)";
export var tpEaseOut = "cubic-bezier(0, 0, 0.40, 1)";
export var tpEaseInOut = "cubic-bezier(0.45, 0, 0.40, 1)";
export var tpFontFamilyBase = "Mark, Avenir, Helvetica, Arial, sans-serif";
export var tpFontFamilyMonospace = "'Source Code Pro', monospace";
export var tpFontWeightNormal = "400";
export var tpFontWeightBold = "700";
export var tpFontTitle1Size = "28px";
export var tpFontTitle1LineHeight = "32px";
export var tpFontTitle1Weight = "700";
export var tpFontTitle1ResponsiveSize = "40px";
export var tpFontTitle1ResponsiveLineHeight = "44px";
export var tpFontTitle1ResponsiveWeight = "700";
export var tpFontTitle2Size = "24px";
export var tpFontTitle2LineHeight = "28px";
export var tpFontTitle2Weight = "700";
export var tpFontTitle2ResponsiveSize = "32px";
export var tpFontTitle2ResponsiveLineHeight = "40px";
export var tpFontTitle2ResponsiveWeight = "700";
export var tpFontTitle3Size = "22px";
export var tpFontTitle3LineHeight = "28px";
export var tpFontTitle3Weight = "700";
export var tpFontTitle3ResponsiveSize = "24px";
export var tpFontTitle3ResponsiveLineHeight = "32px";
export var tpFontTitle3ResponsiveWeight = "700";
export var tpFontTitle4Size = "20px";
export var tpFontTitle4LineHeight = "28px";
export var tpFontTitle4Weight = "700";
export var tpFontTitle5Size = "18px";
export var tpFontTitle5LineHeight = "24px";
export var tpFontTitle5Weight = "700";
export var tpFontTitle6Size = "16px";
export var tpFontTitle6LineHeight = "24px";
export var tpFontTitle6Weight = "700";
export var tpFontTitle7Size = "14px";
export var tpFontTitle7LineHeight = "20px";
export var tpFontTitle7Weight = "700";
export var tpFontTitle8Size = "12px";
export var tpFontTitle8LineHeight = "18px";
export var tpFontTitle8Weight = "700";
export var tpFontBody1Size = "16px";
export var tpFontBody1LineHeight = "24px";
export var tpFontBody2Size = "14px";
export var tpFontBody2LineHeight = "20px";
export var tpFontBody3Size = "12px";
export var tpFontBody3LineHeight = "18px";
export var tpLetterSpacingLoose = "1px";
export var tpLetterSpacingTight = "-1px";
export var tpLetterSpacingExtraTight = "-2px";
export var tpLineHeightBase = "1.6";
export var tpLineHeightTight = "1.4";
export var tpLineHeightLoose = "1.9";
export var tpShadow100 = "0px 1px 3px rgba(0, 0, 0, 0.1)";
export var tpShadow200 = "0px 2px 4px rgba(0, 0, 0, 0.15)";
export var tpShadow300 = "0px 2px 7px rgba(0, 0, 0, 0.15)";
export var tpShadow400 = "0px 2px 10px rgba(0, 0, 0, 0.2)";
// @deprecated
export var tpShadowCard = "0 -1px 1px 0 rgba(0, 0, 0, 0.04), 0 1px 2px 0 rgba(0, 0, 0, 0.16)";
export var tpScrimLight80 = "rgba(255, 255, 255, 0.8)";
export var tpScrimDark80 = "rgba(0, 0, 0, 0.8)";
export var tpSpace1 = "4px";
export var tpSpace2 = "8px";
export var tpSpace3 = "16px";
export var tpSpace4 = "24px";
export var tpSpace5 = "32px";
export var tpSpace6 = "64px";
export var tpSpace7 = "128px";
export var tpSpace8 = "256px";
export var tpWrapMaxWidth = "946px";
export var tpWrapNoPadWidth = "1010px";
export var tpZIndexModal = 200;
